module.exports = __webpack_public_path__ + "img/nick.a9a89738.png";